import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HeadingProvider } from "./HeadingContext";

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode>
    <HeadingProvider>
      <App />
    </HeadingProvider>
  // </React.StrictMode>
);

